
import { defineComponent } from 'vue'
import ListItem from '@/components/ListItem.vue'
import ListPagination from '@/components/ListPagination.vue'
import GridContainer from '@/components/GridContainer.vue'
import GridColumn from '@/components/GridColumn.vue'
import Customily from '@/api/customily'
import { Product } from '@/models/ProductModel'
import Placeholder from '@/assets/placeholder/product.svg'
import ResponsiveComponent from '@/components/ResponsiveComponent.vue'
import InViewport from '@/components/InViewport.vue'
import Loading from '@/components/AtomLoading.vue'

export default defineComponent({
  name: 'PageHome',
  components: {
    ListItem,
    ListPagination,
    GridColumn,
    GridContainer,
    Placeholder,
    ResponsiveComponent,
    InViewport,
    Loading
  },
  data () {
    return {
      items: [] as Product[],
      pagedItems: [] as Product[],
      isLoading: true,
      currentPage: 1,
      totalItems: 11,
      perPage: 8,
      token: '',
      isInfinity: true,
      querySring: ''
    }
  },
  methods: {
    toggleInfinity (value: boolean) {
      this.isInfinity = !value
    },
    async paginationChange (page: number) {
      this.currentPage = page
      await this.getProducts()
      this.setPagedItems()
    },
    getFrom (): number {
      return (this.currentPage * this.perPage) - this.perPage
    },
    getTo (): number {
      return this.getFrom() + this.perPage
    },
    async getProducts () {
      // prevent get items already loaded.
      if (this.items[this.getFrom()] === undefined) {
        this.isLoading = true
        const products = await Customily.getProductsFromTo(this.token, this.querySring, this.getFrom(), this.getTo())
        this.items.push(...products)
        this.isLoading = false
      }
      this.setPagedItems()
    },
    setPagedItems () {
      this.pagedItems = [...this.items]
      if (!this.isInfinity) {
        this.pagedItems = this.items.slice(this.getFrom(), this.getTo())
      }
    },
    getPlaceholderItems ():number {
      return this.currentPage * this.perPage < this.totalItems ? this.perPage : this.perPage - ((this.currentPage * this.perPage) - this.totalItems)
    },
    viewMoreInViewport () {
      if (!this.isLoading) {
        this.paginationChange(this.currentPage + 1)
      }
    }
  },
  async mounted () {
    const { access_token: accessToken } = await Customily.getToken()
    this.token = accessToken
    await this.getProducts()
    // const products = await Customily.getProductsFromTo(accessToken, '', this.getFrom(), this.getTo())
  }
})
